import styled, { css } from "styled-components";

const SelectStyled = styled.div`
  label {
    opacity: 0;
    height: 1px;
    clip: rect(1px, 1px, 1px, 1px);
  }
  
  .isGreen {
    padding:30px;
    color: green;
  }

  select {
    height: 5rem;
    font-size: 1.4rem;
    line-height: 1.5;
    padding: 1.1em 2rem;
  }
  /* focused */
  ${(props) => {
    return (
      props.focused &&
      css`
        label {
          display: block;
          font-size: 1.2rem;
          top: 2rem;
          font-weight: bold;

          ${(props) => props.showLabel && "opacity: 1"};
          ${(props) => props.showLabel && "height: auto"};
          ${(props) => props.showLabel && "clip: unset"};
        }
        select {
          line-height: normal; /* safari fix */
          padding-top: 2rem;
          padding-bottom: 0;
        }
      `
    );
  }}
`;

export default SelectStyled;
